import { render, staticRenderFns } from "./CbxMaritalStatus.vue?vue&type=template&id=06f289b6&"
import script from "./CbxMaritalStatus.vue?vue&type=script&lang=ts&"
export * from "./CbxMaritalStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports